import React from 'react';
import Layout from '../../components/Layout';

const DashboardFeature = () => {
  return (
    <Layout>
      <div className="py-12">
        <h2 className="text-4xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-teal-400 to-blue-400 mb-6">
          MVP Core Utility Dashboard
        </h2>
        <p className="text-lg text-gray-300 max-w-3xl mx-auto mb-10">
          This section contains the minimum viable product's key functionality. 
          Here, users interact with the decentralized data or core service.
        </p>

        {/* Placeholder for the main feature block */}
        <div className="bg-gray-800 p-8 rounded-xl shadow-2xl border border-teal-500/30">
          <h3 className="text-2xl font-semibold text-white mb-4">Data Visualization Block</h3>
          <div className="h-64 flex items-center justify-center text-gray-500 text-xl italic">
            [Connect Wallet Button / Live Data Feed Placeholder]
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default DashboardFeature;
